<template>
  <div class="row">
    <Loader v-if="!resourceLoaded" />
    <div class="col-12" v-if="resourceLoaded">
      <div class="panel-content-inner">
        <div class="row payment-tab-container">
          <table
            id="reservations-table"
            class="superconciergerie-table-secondary table text-center"
            style="min-width:1280px;"
          >
            <thead>
              <tr>
                <th>
                  {{ $t("superconcierge.reservations.rental_name") }}
                </th>
                <th>
                  {{ $t("superconcierge.reservations.platform") }}
                </th>
                <th>
                  {{ $t("superconcierge.reservations.guest") }}
                </th>
                <th>
                  {{ $t("superconcierge.reservations.checkin") }}
                </th>
                <th>
                  {{ $t("superconcierge.reservations.checkout") }}
                </th>
                <th>
                  {{ $t("superconcierge.reservations.nbr_nights") }}
                </th>
                <th>
                  {{ $t("superconcierge.reservations.nbr_guests") }}
                </th>
                <th>
                  {{ $t("superconcierge.reservations.total_price") }}
                </th>
                <th>
                  {{ $t("superconcierge.reservations.status") }}
                </th>
                <th style="font-weight: bold">
                  {{ $t("superconcierge.reservations.concierge_cleaning") }}
                  <i data-toggle="popover" data-content="Facturée par la conciergerie" class="fa fa-info-circle fa-specified"></i>
                </th>
                <th style="font-weight: bold">
                  {{ $t("superconcierge.reservations.concierge_linen") }}
                  <i data-toggle="popover" data-content="Facturée par la conciergerie" class="fa fa-info-circle fa-specified"></i>
                </th>
                <th style="font-weight: bold">
                  {{ $t("superconcierge.reservations.concierge_checkin") }}
                  <i data-toggle="popover" data-content="Facturée par la conciergerie" class="fa fa-info-circle fa-specified"></i>
                </th>
                <th style="font-weight: bold">
                  {{ $t("superconcierge.reservations.concierge_commission") }}
                  <i data-toggle="popover" data-content="Base de calcul x taux commission" class="fa fa-info-circle fa-specified"></i>
                </th>
                <th style="font-weight: bold">
                  {{ $t("superconcierge.reservations.concierge_fees") }}
                  <i data-toggle="popover" data-content="Commission + forfait 1 + forfait 2" class="fa fa-info-circle fa-specified"></i>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="booking in filteredBookings" :key="booking.id">
                <td>
                  <div>
                    <a
                      class="m-b-10 product-price action-title"
                      :href="'#/rentals/' + booking.rental_id"
                      target="_blank"
                    >{{ booking.rental_name }}</a
                    >
                  </div>
                </td>
                <td>
                  <div>
                    {{ booking.platform }}
                  </div>
                </td>
                <td>
                  <div>
                    <a
                      class="m-b-10 product-price action-title"
                      :href="'#/bookings/' + booking.id +  '/informations'"
                      target="_blank"
                    >
                    {{ booking.guest.first_name }} {{ booking.guest.last_name}}
                    </a>
                  </div>
                </td>
                <td>
                  <div>
                    {{ moment(booking.checking).format("DD/MM/YYYY") }}
                  </div>
                </td>
                <td>
                  <div>
                    {{ moment(booking.checkout).format("DD/MM/YYYY") }}
                  </div>
                </td>
                <td>
                  <div>
                    {{ booking.nbr_nights }}
                  </div>
                </td>
                <td>
                  <div>
                    {{ booking.nbr_guests }}
                  </div>
                </td>
                <td>
                  <div>
                    {{ booking.total_price.toFixed(2) }}{{ booking.currency }}
                  </div>
                </td>
                <td>
                  <div>
                    {{ $t("booking.detail.status."+booking.status) }}
                  </div>
                </td>
                <td>
                  <div style="font-weight: 600"
                       :id="'booking-' + booking.id + '-superconcierge_cleaning_fees'"
                       @click.prevent="
                      showInputField(booking, 'superconcierge_cleaning_fees', 'booking-', updateBooking, this)
                    ">
                    {{ booking.superconcierge_cleaning_fees.toFixed(2) }}
                    {{ booking.currency }}
                  </div>
                </td>
                <td>
                  <div  style="font-weight: 600"
                        :id="'booking-' + booking.id + '-superconcierge_linen_fees'"
                        @click.prevent="showInputField(booking, 'superconcierge_linen_fees', 'booking-', updateBooking, this)" >
                    {{ booking.superconcierge_linen_fees.toFixed(2) }}
                    {{ booking.currency }}
                  </div>
                </td>
                <td>
                  <div  style="font-weight: 600"
                        :id="'booking-' + booking.id + '-superconcierge_checkin_fees'"
                        @click.prevent="showInputField(booking, 'superconcierge_checkin_fees', 'booking-', updateBooking, this)" >
                    {{ booking.superconcierge_checkin_fees.toFixed(2) }}
                    {{ booking.currency }}
                  </div>
                </td>
                <td>
              <div style="font-weight: 600; cursor:pointer" data-toggle="popover" data-content="Mars : 95€<br/>Avril : 100€">
<!--                  <div style="font-weight: 600">-->
                    {{ booking.concierge_commission.toFixed(2) }}
                    {{ booking.currency }}
                  </div>
                </td>
                <td>
                <div style="font-weight: 600; cursor:pointer" data-toggle="popover" data-content="Calcul">
<!--                    <div style="font-weight: 600">-->
                    {{ booking.concierge_fees.toFixed(2) }}
                    {{ booking.currency }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import superconciergerie from "../../../services/superconciergerie";
import mixin from "../../../mixins/mixin";
import moment from "moment";
export default {
  data() {
    return {
      resourceLoaded: false,
      booking: {},
      bookings: [],
      filteredBookings: [],
      rentals: [],
      filteredRentals: [],
      filteredRentalIds: [],
      owners: [],
      filteredOwners: [],
      filteredOwnerIds: [],
      status: [],
      filteredStatus: [],
      filteredStatusIds: [],
      guest: {},
      exportName: '',
    };
  },

  mixins: [mixin],
  methods: {
    moment,
    async export() {
      // convert this.filteredBookings to csv
      console.log(this.filteredBookings)
      const bookings = this.filteredBookings.map((booking) => {
        return [booking.id, booking.rental_name, booking.guest.first_name, booking.guest.last_name, booking.checking, booking.checkout, booking.nbr_adults, booking.nbr_children, booking.price, booking.cleaning, booking.city_taxes, booking.commission, booking.service_charges, booking.other_charges, booking.payment_charges, booking.superconcierge_cleaning_fees, booking.superconcierge_linen_fees, booking.superconcierge_checkin_fees, booking.channel.name, booking.booking_date, booking.status, moment(booking.checking).format("MM"), moment(booking.checkout).format("MM"), moment(booking.checking).format("YYYY"), moment(booking.checkout).format("YYYY")];
      });

      let csv = 'ID,Hébergement,Prénom,Nom,Arrivée,Départ,NB Adultes,NB Enfants,Prix Nuitées,Ménage facturé voyageur,Taxes séjour,Commission Plateforme, Frais service plateforme, Autre frais plateforme,Frais de paiement,Frais ménage conciergerie,Frais linge conciergerie,Frais checkin conciergerie,Plateforme,Date réservation,Status,Mois arrivée,Mois départ,Année arrivée,Année départ\n';
      for(let i = 0; i < bookings.length; i++) {
        csv += bookings[i].join(',');
        csv += '\n';
      }
      // download csv
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", `${this.exportName}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    async loadResource() {
      if (this.activeTab === "reservations" && !this.resourceLoaded) {
        await superconciergerie.getBookings(this);

        this.$root.$emit('reservations_rentals_setFilterElems', this.filteredRentals);
        this.$root.$emit('reservations_rentals_setFilterFallback', (ids) => this.filterData(ids, this, "rentals"));

        this.$root.$emit('reservations_owners_setFilterElems', this.filteredOwners);
        this.$root.$emit('reservations_owners_setFilterFallback',(ids) => this.filterData(ids, this, "owners"));

        this.$root.$emit('reservations_status_setFilterElems', this.filteredStatus);
        this.$root.$emit('reservations_status_setFilterFallback',(ids) => this.filterData(ids, this, "status"));

        this.$root.$emit('reservations_dates_setDateFilterFallback',(date) => {
          this.resourceLoaded = false;
          superconciergerie.getBookings(this, date).then(() => {
            this.resourceLoaded = true;

            this.filteredBookings = this.bookings.filter((booking) => {
              const statusMatch = !this.filteredStatusIds.length || this.filteredStatusIds.includes(booking.status);
              const rentalMatch = !this.filteredRentalIds.length || this.filteredRentalIds.includes(booking.rental.id);
              const ownerMatch = !this.filteredOwnerIds.length || (booking.rental.owner && this.filteredOwnerIds.includes(booking.rental.owner.id));

              return rentalMatch && ownerMatch && statusMatch;
            });
          });
          const id = moment().format("HHmmss");
          this.exportName = `reservations-${
            moment(date.year+"-"+date.month).format("YYYY-MM")
          }-${id}`;

        });

        this.resourceLoaded = true;

        const waitForPopoverToLoad = setInterval(() => {
          if(document.querySelectorAll("[data-toggle=\"popover\"]").length > 0) {
            clearInterval(waitForPopoverToLoad);
            $('[data-toggle="popover"]').popover({
              placement: "left",
              html: true,
            });
          }
        }, 500);
      }
    },
    filterData(data, context, target) {
      if(target === "rentals") {
        context.filteredRentalIds = data;
      } else if(target === "status") {
        context.filteredStatusIds = data;
      } else {
        context.filteredOwnerIds = data;
      }

      context.filteredBookings = this.bookings.filter((booking) => {
        const statusMatch = !context.filteredStatusIds.length || context.filteredStatusIds.includes(booking.status);
        const rentalMatch = !context.filteredRentalIds.length || context.filteredRentalIds.includes(booking.rental.id);
        const ownerMatch = !context.filteredOwnerIds.length || (booking.rental.owner && context.filteredOwnerIds.includes(booking.rental.owner.id));

        return rentalMatch && ownerMatch && statusMatch;
      });
    },
    async updateBooking(booking, field, vm) {
      const bookingId = booking.id;
      if (!document.getElementById("input-" + bookingId + "-" + field)) {
        return;
      }
      let value = document.getElementById(
        "input-" + bookingId + "-" + field
      ).value;

      if (booking[field] != value) {
        booking[field] = value;
        await superconciergerie.updateBooking(this, booking);
      }

      document.getElementById("booking-" + bookingId + "-" + field).innerHTML =
        parseFloat(value).toFixed(2) + " " + booking.currency;

      vm.updateField = null;
      this.resourceLoaded = false;
      this.loadResource();
    },
  },
  props: ["activeTab", "showInputField"],
  async mounted() {
    // await this.loadResource();

  },
  watch: {
    activeTab: async function (val) {
      await this.loadResource();
    },
    bookings: async function (val) {
      // Get rentals
      const rentals = [];
      val.forEach((booking) => {
        if (!rentals.find((rental) => rental.id === booking.rental_id)) {
          rentals.push(booking.rental);
        }
      });
      this.rentals = rentals;
      this.filteredRentals = rentals;

      // Get owners
      this.owners = this.rentals.map(rental => rental.owner);
      this.owners = this.owners.filter(o => o != null);
      this.owners = this.owners.filter((owner, index, self) =>
          index === self.findIndex((t) => (
            t.id === owner.id
          ))
      );
      this.filteredOwners = this.owners;

      // Get status
      // this.status = this.bookings.map(b => {
      //   return {
      //     'id': b.status,
      //     'name': b.status.charAt(0).toUpperCase() + b.status.slice(1),
      //   }
      // });
      // console.log(this.status)
      // this.status = this.status.filter((status, index, self) =>
      //     index === self.findIndex((t) => (
      //       t.id === status.id
      //     ))
      // );
      // improve it with a reduce ?
      this.status = this.bookings.reduce((acc, b) => {
        if (!acc.find((s) => s.id === b.status)) {
          acc.push({
            'id': b.status,
            'name': b.status.charAt(0).toUpperCase() + b.status.slice(1),
          });
        }
        return acc;
      }, []);

      this.filteredStatus = this.status;
    },
  },
  components: {
    Loader: require('../components/Loader.vue'),
  },
};
</script>



// WEBPACK FOOTER //
// ReservationsTab.vue?72261c75